import type { InventoryViewMode } from '../context/InventoryViewModeContext';

export const INVENTORY_MOBILE_QR_QUERY_MOBILE = 'mobile';
export const INVENTORY_MOBILE_QR_QUERY_VUE = 'vue';

export function buildInventoryMobileOpenUrl(
  origin: string,
  reference: string,
  viewMode: InventoryViewMode,
): string {
  const params = new URLSearchParams({
    [INVENTORY_MOBILE_QR_QUERY_MOBILE]: '1',
    [INVENTORY_MOBILE_QR_QUERY_VUE]: viewMode,
  });

  const path = `/inventaire/${encodeURIComponent(reference)}`;

  return `${origin.replace(/\/$/, '')}${path}?${params.toString()}`;
}

export function parseInventoryViewModeFromMobileQrSearch(
  searchParams: URLSearchParams,
): InventoryViewMode | undefined {
  if (searchParams.get(INVENTORY_MOBILE_QR_QUERY_MOBILE) !== '1') {
    return undefined;
  }

  const vue = searchParams.get(INVENTORY_MOBILE_QR_QUERY_VUE);

  if (vue === 'superviseur' || vue === 'inventoriste') {
    return vue;
  }

  return undefined;
}
